"use client";

import { useState, useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import FilterButton from "./filter-button";
import FilterPanel from "./filter-panel";
import {
  FilterStatistics,
  Country,
  City,
} from "@/app/(platform)/events/actions";

interface FilterData {
  countries: Country[];
  cities: City[];
  years: number[];
  statistics: FilterStatistics;
}

interface FilterPanelWrapperProps {
  filterData: FilterData;
  currentFilters: {
    search?: string;
    countrySlug?: string;
    countryName?: string;
    citySlug?: string;
    cityName?: string;
    month?: string;
    year?: string;
    type?: "upcoming" | "past" | "all";
  };
}

export default function FilterPanelWrapper({
  filterData,
  currentFilters,
}: FilterPanelWrapperProps) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [showFilters, setShowFilters] = useState(false);

  // Check if filters should be open based on URL parameter
  useEffect(() => {
    const shouldShowFilters = searchParams.get("filters") === "on";
    setShowFilters(shouldShowFilters);
  }, [searchParams]);

  const activeFilterCount = [
    currentFilters.search,
    currentFilters.countryName,
    currentFilters.cityName,
    currentFilters.year,
    currentFilters.month,
    currentFilters.type !== "upcoming" ? currentFilters.type : null,
  ].filter(Boolean).length;

  const handleClose = () => {
    setShowFilters(false);
    // Remove filters=on from URL when closing
    const params = new URLSearchParams(searchParams);
    params.delete("filters");
    const currentPath = window.location.pathname;
    const queryString = params.toString();
    const newUrl = queryString ? `${currentPath}?${queryString}` : currentPath;

    // Use router to update URL without page reload
    router.replace(newUrl, { scroll: false });
  };

  return (
    <>
      <FilterButton
        onToggle={() => setShowFilters(!showFilters)}
        activeFilterCount={activeFilterCount}
      />
      {showFilters && (
        <div className="col-span-2 mt-4">
          <FilterPanel
            filterData={filterData}
            currentFilters={currentFilters}
            onClose={handleClose}
          />
        </div>
      )}
    </>
  );
}
